/* eslint-disable array-callback-return */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { Box, InputAdornment, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import TableSortLabel from '@mui/material/TableSortLabel';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import TableFooter from '@mui/material/TableFooter';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { visuallyHidden } from '@mui/utils';

import Iconify from './Iconify';
import Alerta from './alertas';
import { isEmpty } from '../auxiliares/funciones';
import RCheck from './forms/inputs/RCheck';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  whiteSpace: 'nowrap',
  padding: '10px 12px',
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    fontSize: 13,
  },
  [`&.${tableCellClasses.footer}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 13,
    whiteSpace: 'nowrap',
  },
}));

const MyTableFooter = styled(TableFooter)(({ theme }) => ({
  borderTop: '2px solid',
  borderColor: theme.palette.primary.main,
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function TablePaginationActions(props) {
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = () => {
    onPageChange(0);
  };

  const handleBackButtonClick = () => {
    onPageChange(page - 1);
  };

  const handleNextButtonClick = () => {
    onPageChange(page + 1);
  };

  const handleLastPageButtonClick = () => {
    onPageChange(Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5, color: 'white !important' }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="primera página"
      >
        <FirstPageIcon />
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="página anterior"
      >
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="página siguiente"
      >
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="última página"
      >
        <LastPageIcon />
      </IconButton>
    </Box>
  );
}

class RTabla extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listado: this.props.lista ? this.props.lista : [],
      listadoO: this.props.lista ? this.props.lista : [],
      cabecera: this.props.cabecera ? this.props.cabecera : [],
      campos: this.props.campos ? this.props.campos : [],
      scroll: this.props.scroll ? this.props.scroll : false,
      check: this.props.check ? this.props.check : false,
      checkId: this.props.checkId ? this.props.checkId : null,
      page: 0,
      rowsPerPage: this.props.rowsPerPage ? this.props.rowsPerPage : 25,
      order: 'asc',
      orderBy: -1,
      busqueda: this.props.busqText !== undefined ? this.props.busqText : '',
    };
  }

  componentDidMount() {
    if (this.state.scroll) {
      window.scrollTo(0, 280);
    }
    if (this.props.busqText !== undefined) {
      this.buscaTabla({ target: { value: this.props.busqText } });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.lista !== this.props.lista) {
      let newLista = this.props.lista || [];
      if (this.state.orderBy !== -1) {
        newLista = this.stableSort(newLista, this.getComparator(this.state.order, this.state.orderBy));
      }
      this.setState({
        listadoO: newLista,
        listado: newLista,
        page: 0,
      });
    }
  }

  handleChangePage = (newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ page: 0, rowsPerPage: parseInt(event.target.value, 10) });
  };

  buscaTabla = (input) => {
    const { listadoO, campos } = this.state;
    const query = (input.target.value || '').toLowerCase();
    const datos = listadoO.filter((item) =>
      campos.some((key) =>
        String(item[key] !== null && item[key] !== undefined ? item[key] : '')
          .toLowerCase()
          .includes(query)
      )
    );
    this.setState({ listado: datos, busqueda: input.target.value, page: 0 });
    if (this.props.busqText !== undefined) {
      this.props.actualizaBusc(input.target.value);
    }
  };

  descendingComparator = (a, b, orderBy) => {
    const { campos } = this.state;
    const fieldKey = campos[orderBy];
    if (!fieldKey) return 0;

    let valA = a[fieldKey];
    let valB = b[fieldKey];

    if (valA === null || valA === undefined) valA = '';
    if (valB === null || valB === undefined) valB = '';

    const numA = Number(valA);
    const numB = Number(valB);
    if (!Number.isNaN(numA) && !Number.isNaN(numB) && String(valA).trim() !== '' && String(valB).trim() !== '') {
      if (numB < numA) return -1;
      if (numB > numA) return 1;
      return 0;
    }

    const strA = String(valA).toLowerCase();
    const strB = String(valB).toLowerCase();
    return strB.localeCompare(strA, 'es', { numeric: true, sensitivity: 'base' });
  };

  getComparator = (order, orderBy) =>
    order === 'desc'
      ? (a, b) => this.descendingComparator(a, b, orderBy)
      : (a, b) => -this.descendingComparator(a, b, orderBy);

  stableSort = (array, comparator) => {
    const stabilizedThis = (array || []).map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  };

  createSortHandler = (id) => () => {
    const { order, orderBy, listado, listadoO } = this.state;
    const isAsc = orderBy === id && order === 'asc';
    const orderA = isAsc ? 'desc' : 'asc';
    const comparator = this.getComparator(orderA, id);

    const sortedListado = this.stableSort(listado, comparator);
    const sortedListadoO = this.stableSort(listadoO, comparator);

    this.setState({
      order: orderA,
      orderBy: id,
      page: 0,
      listado: sortedListado,
      listadoO: sortedListadoO,
    });
  };

  render() {
    const { cabecera, campos, listado, listadoO, page, rowsPerPage, order, orderBy, busqueda } = this.state;
    const { acciones } = this.props;
    return (
      <Box sx={{ width: '100%', boxSizing: 'border-box' }}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2, width: '100%' }}>
          <TextField
            placeholder="Buscar en la tabla"
            value={busqueda}
            onChange={(e) => this.buscaTabla(e, 'eventos')}
            type="text"
            name="buscar"
            autoComplete="off"
            size="small"
            sx={{ width: { xs: '100%', sm: '300px' } }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Iconify icon={'eva:search-fill'} sx={{ width: 20, height: 20, color: 'text.disabled' }} />
                </InputAdornment>
              ),
            }}
          />
        </Box>
        {isEmpty(listado) && !isEmpty(listadoO) && (
          <Box sx={{ mb: 2 }}>
            <Alerta tipo="warning" titulo="No hay ningun resultado con ese filtro." />
          </Box>
        )}
        {isEmpty(listado) && isEmpty(listadoO) && (
          <Box sx={{ mb: 2 }}>
            <Alerta tipo="info" titulo="La tabla está vacía" />
          </Box>
        )}

        <Box
          sx={{
            width: '100%',
            maxWidth: '100%',
            minWidth: 0,
            overflowX: 'auto !important',
            display: 'block',
            mb: 4,
            borderRadius: 2,
            border: '1px solid #CBD5E1',
            WebkitOverflowScrolling: 'touch',
            touchAction: 'pan-x pan-y',
          }}
        >
          <TableContainer sx={{ width: '100%', maxWidth: '100%', minWidth: 0, overflowX: 'auto !important', display: 'block' }}>
            <Table sx={{ minWidth: 1100, tableLayout: 'auto' }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  {this.state.check && <StyledTableCell align="right">{''}</StyledTableCell>}
                  {cabecera.map((c, id) => (
                    <StyledTableCell key={id} align="right">
                      <TableSortLabel
                        active={orderBy === id}
                        direction={orderBy === id ? order : 'asc'}
                        onClick={this.createSortHandler(id)}
                      >
                        {c}
                        {orderBy === id ? (
                          <Box component="span" sx={visuallyHidden}>
                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                          </Box>
                        ) : null}
                      </TableSortLabel>
                    </StyledTableCell>
                  ))}
                  {!isEmpty(acciones) && <StyledTableCell align="right">{''}</StyledTableCell>}
                </TableRow>
              </TableHead>
              <TableBody>
                {(rowsPerPage > 0 ? listado.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : listado).map(
                  (g, id) => (
                    <StyledTableRow key={id}>
                      {this.state.check && (
                        <StyledTableCell align="right">
                          <RCheck
                            name={g[this.state.checkId]}
                            label=""
                            actualizaCampo={this.props.marcaCheck}
                            value={g.marcado}
                            md={1}
                          />
                        </StyledTableCell>
                      )}
                      {campos.map((c, id2) => (
                        <StyledTableCell key={id2} align="right">
                          {g[c]}
                        </StyledTableCell>
                      ))}
                      {!isEmpty(acciones) && (
                        <StyledTableCell align="right">
                          <ButtonGroup sx={{ maxHeight: '36px' }} variant="contained" aria-label="outlined primary button group">
                            {acciones.map((a, i) => {
                              if (a.condition === null || a.condition(g, id)) {
                                return (
                                  <Button
                                    variant="contained"
                                    sx={a.estilo}
                                    onClick={() => {
                                      if (a.funcion !== null) a.funcion(g);
                                    }}
                                    color={a.color}
                                    key={i}
                                  >
                                    {a.icono}
                                    {a.nombre}
                                  </Button>
                                );
                              }
                              return null;
                            })}
                          </ButtonGroup>
                        </StyledTableCell>
                      )}
                    </StyledTableRow>
                  )
                )}
              </TableBody>
              <MyTableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25, { label: 'Todos', value: -1 }]}
                    colSpan={12}
                    count={listado.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    labelRowsPerPage="Resultados por página"
                    SelectProps={{
                      inputProps: {
                        'aria-label': 'Resultados por página',
                      },
                      native: true,
                    }}
                    onPageChange={this.handleChangePage}
                    onRowsPerPageChange={(event) => this.handleChangeRowsPerPage(event)}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </MyTableFooter>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    );
  }
}

export default RTabla;
